<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-26 15:40:19
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2019-08-26 17:24:50
 * @Description: file content
 评论区
 -->
<template>
  <div class="container">
    <div class="discuss">
      <div class="title">
        <div class="leave_word" @click="clickLeaveWord">
          写留言
          <img src="http://assets.rurushishi.com/h5/img/wx_edit.png" />
        </div>
      </div>
      <div class="content discuss_content"></div>
    </div>
    <div class="board" v-if="isShowBoard">
      <div class="remind"></div>
      <div
        class="editor"
        ref="discussEditor"
        contenteditable="true"
        data-placeholder="留言将由公众号筛选后显示，对所有人可见。"
      ></div>
      <div class="leaving" @click="clickLeaving">留言</div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
export default {
  components: {},
  props: {},
  data() {
    return {
      isShowBoard: false
    };
  },
  watch: {},
  computed: {
    ...mapState(["pageInfo"])
  },
  methods: {
    // 点击写留言
    clickLeaveWord() {
      this.isShowBoard = true;
      history.pushState(null, "", "");
      let that = this;
      window.onpopstate = function(event) {
        that.isShowBoard = false;
      };
    },
    // 留言
    clickLeaving() {
      let that = this;
      var strTxt = this.$refs.discussEditor.innerHTML;
      if (strTxt.length == 0) {
        util.messageBox("留言不能为空");
        return;
      }
      comreq.commentSave(this.pageInfo.PageId, strTxt).then(function(data) {
        if (data && data.obj && data.obj == 1) {
          that.getCommentList();
          that.isShowBoard = false;
        } else {
          util.messageBox("不支持emoji表情输入！");
        }
      });
    },
    // 获取评论列表
    getCommentList() {
      let that = this;
      comreq.getCommentList(this.pageInfo.PageId).then(function(data) {
        if (data && data.obj && data.obj.list && data.obj.list.length > 0) {
          that.dealGetCommentList(data.obj.list);
        }
      });
    },
    dealGetCommentList(listPar) {
      var strHtml = "";
      var list = [];
      for (var i = 0; i < listPar.length; i++) {
        if (listPar[i].ismine) {
          list.splice(0, 0, listPar[i]);
        } else {
          list.push(listPar[i]);
        }
      }

      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        strHtml += ` <div class="item" id="item${item.id}">
        <div class="head">
            <img src="${item.headimgurl ||
              "http://assets.rurushishi.com/h5/img/default_head.jpg"}">
        </div>
        <div class="result">
            <div class="author">
                <div class="text">
                    <div class="nickname">${item.nickname || "默认用户"}</div>
                    <div class="message">${item.content}</div>
                    <div class="oper">
                        <span class="time">${util.formatDateLikeWx(
                          util.getFullTime(item.createdtime)
                        )}</span> 
                        ${
                          item.ismine
                            ? `
                            <span class="del del115" data-id="${item.id}" >删除</span>
                            `
                            : ""
                        }
                    </div>
                </div>
                <div class="praise">
                    <div class="praise_inside" data-id="${item.id}">
                        <img id="praise${item.id}" data-id="${item.id}" src="${
          item.islike
            ? "http://assets.rurushishi.com/h5/img/wx_praise.png"
            : "http://assets.rurushishi.com/h5/img/wx_unpraise.png"
        }">
                        <span id="praiseCount${item.id}" data-id="${
          item.id
        }" class="praise_count">${item.like}</span>
                    </div>
                 </div>
            </div>

             ${
               item.isreply
                 ? `
                <div class="auditor">
                <div class="text">
                    <div class="nickname">
                        作者回复</div>
                    <div class="message">${item.replycomment.content}</div>
                    <div class="oper">
                        <span class="time">${util.formatDateLikeWx(
                          util.getFullTime(item.replycomment.createdtime)
                        )}</span> 
                    </div>
                </div>
                <div class="praise">
                     <div class="praise_inside" data-id="${
                       item.replycomment.id
                     }">
                        <img id="praise${item.replycomment.id}" data-id="${
                     item.replycomment.id
                   }"  src="${
                     item.replycomment.islike
                       ? "http://assets.rurushishi.com/h5/img/wx_praise.png"
                       : "http://assets.rurushishi.com/h5/img/wx_unpraise.png"
                   }">
                        <span id="praiseCount${
                          item.replycomment.id
                        }" data-id="${
                     item.replycomment.id
                   }"  class="praise_count">${item.replycomment.like}</span>
                    </div>
                 </div>
            </div>
             `
                 : ""
             }
        </div>
            </div>`;
      }
      document.getElementsByClassName("discuss_content")[0].innerHTML = strHtml;
      // 点赞
      let eles_praise_inside = document.getElementsByClassName("praise_inside");
      for (let index = 0; index < eles_praise_inside.length; index++) {
        eles_praise_inside[index].addEventListener("click", function(e) {
          var id = e.target.dataset.id;
          var islike = -1;
          var praiseObj = document.getElementById("praise" + id);
          var praiseCountObj = document.getElementById("praiseCount" + id);
          var parseCount = parseInt(praiseCountObj.innerText);
          if (praiseObj.src.indexOf("unpraise") > -1) {
            islike = 1;
          } else {
            islike = 0;
          }
          if (islike) {
            praiseObj.src = "http://assets.rurushishi.com/h5/img/wx_praise.png";
            praiseCountObj.innerText = parseCount + 1;
          } else {
            praiseObj.src =
              "http://assets.rurushishi.com/h5/img/wx_unpraise.png";
            praiseCountObj.innerText = parseCount - 1;
          }
          comreq.doLikeComment(id, islike);
        });
      }

      // 删除
      let eles_del115 = document.getElementsByClassName("del115");
      for (let index = 0; index < eles_del115.length; index++) {
        eles_del115[index].addEventListener("click", function(e) {
          var id = e.target.dataset.id;
          var idObject = document.getElementById("item" + id);
          idObject.parentNode.removeChild(idObject);
          comreq.deleteComment(id);
        });
      }
    }
  },
  created() {
    this.getCommentList();
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.container {
  padding: 0 4%;
}

.discuss {
}

.discuss .title {
  overflow: hidden;
  margin-bottom: 10px;
}

.discuss .title .leave_word {
  color: #6684a9;
  float: right;
}

.discuss .title .leave_word img {
  width: 15px;
}

.discuss .content {
}

.discuss .content >>> .item {
  overflow: hidden;
  margin-bottom: 20px;
}

.discuss .content >>> .item .head {
  float: left;
  overflow: hidden;
  width: 15%;
}

.discuss .content >>> .item .head img {
  width: 80%;
}

.discuss .content >>> .item .result {
  float: left;
  overflow: hidden;
  width: 85%;
}

.discuss .content >>> .item .result .author {
  overflow: hidden;
  margin-bottom: 10px;
}

.discuss .content >>> .item .result .auditor {
  overflow: hidden;
  border-top: 1px solid #e6e6e6;
  padding-top: 10px;
}

.discuss .content >>> .item .result .text {
  float: left;
  overflow: hidden;
  width: 82%;
}

.discuss .content >>> .item .result .praise {
  float: left;
  overflow: hidden;
  width: 18%;
}

.discuss .content >>> .item .result .praise .praise_inside {
  text-align: center;
}

.discuss .content >>> .item .result .praise .praise_inside img {
  width: 15px;
}

.discuss .content >>> .item .result .nickname {
  color: #727272;
}

.discuss .content >>> .item .result .auditor .nickname {
  border-left: 4px solid #03bb00;
  padding-left: 10px;
}

.discuss .content >>> .item .result .message {
  margin-top: 3px;
}

.discuss .content >>> .item .result .oper {
  font-size: 12px;
  margin-top: 5px;
}

.discuss .content >>> .item .result .oper .time {
  color: #c2c2c2;
}

.discuss .content >>> .item .result .oper .del {
  color: #6c89ac;
  margin-left: 5px;
}

.discuss .content >>> .item .result .praise_count {
  color: #727272;
}

.board {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #f3f3f3;
  z-index: 1;
}

.board .remind {
  height: 50px;
  line-height: 50px;
  margin-left: 15px;
}

.board .editor {
  width: 100%;
  height: 100px;
  background-color: #ffffff;
  padding: 10px;
  border-top: 1px solid #edeceb;
  border-bottom: 1px solid #edeceb;
  font-size: 13px;
  word-break: break-all;
}

.board .editor:empty:before {
  content: attr(data-placeholder);
  color: #bbb;
}

.board .editor:focus:before {
  content: none;
}

.board .leaving {
  margin: 20px 5%;
  background-color: #07be00;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 5px;
  color: white;
}
</style>